import React, { useRef } from "react";

const feedbacks = [
    {
        name: "Ahmad Geidt",
        desc: 'Lorem Ipsum',
        message: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a lore galley of type and scrambled it to make a type specimen book. Proin vulputate metus in commodo iaculis.",
        image: "https://randomuser.me/api/portraits/men/32.jpg",
        rating: 4
    },
    {
        name: "Mary Joe",
        desc: 'Lorem Ipsum',
        message: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a lore galley of type and scrambled it to make a type specimen book. Proin vulputate metus in commodo iaculis.",
        image: "https://randomuser.me/api/portraits/men/32.jpg",
        rating: 4
    },
    {
        name: "Chris Doe",
        desc: 'Lorem Ipsum',
        message: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a lore galley of type and scrambled it to make a type specimen book. Proin vulputate metus in commodo iaculis.",
        image: "https://randomuser.me/api/portraits/men/32.jpg",
        rating: 5
    }
];

const Feedback = () => {
    const carouselRef = useRef(null);

    const scrollLeft = () => {
        carouselRef.current.scrollBy({ left: -carouselRef.current.offsetWidth, behavior: "smooth" });
    };

    const scrollRight = () => {
        carouselRef.current.scrollBy({ left: carouselRef.current.offsetWidth, behavior: "smooth" });
    };

    return (
        <section id="testimonials" className="py-20 bg-[#08206B]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-4xl lg:text-5xl font-bold text-white">What Our Clients Say</h2>
                </div>

                {/* Carousel */}
                <div className="relative">
                    {/* Carousel Controls */}
                    <button onClick={scrollLeft} className="absolute left-[-35px] top-1/2 transform -translate-y-1/2 z-10 text-white font-medium text-2xl rounded-full shadow-lg">
                        <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.6663 4.90134C18.9778 4.90092 19.2797 4.97552 19.5196 5.11217C19.6546 5.18913 19.7662 5.28364 19.848 5.39029C19.9298 5.49694 19.9802 5.61364 19.9963 5.7337C20.0124 5.85376 19.9939 5.97483 19.9419 6.08996C19.8898 6.2051 19.8052 6.31205 19.6929 6.40467L13.7196 11.318L19.4796 16.2405C19.5904 16.3343 19.6731 16.4422 19.723 16.558C19.7729 16.6738 19.789 16.7952 19.7704 16.9153C19.7518 17.0355 19.6989 17.1519 19.6147 17.2579C19.5304 17.3639 19.4166 17.4574 19.2796 17.533C19.1417 17.6165 18.9801 17.6794 18.8051 17.7179C18.6301 17.7564 18.4454 17.7696 18.2626 17.7567C18.0798 17.7438 17.9028 17.705 17.7429 17.6429C17.5829 17.5807 17.4433 17.4965 17.3329 17.3955L10.8929 11.8955C10.6968 11.7315 10.5896 11.5257 10.5896 11.3134C10.5896 11.1011 10.6968 10.8954 10.8929 10.7313L17.5596 5.23134C17.6934 5.12041 17.8633 5.03272 18.0556 4.97538C18.2478 4.91804 18.4571 4.89268 18.6663 4.90134Z" fill="#F7F7F7" />
                        </svg>

                    </button>
                    <button onClick={scrollRight} className="absolute right-[-35px] top-1/2 transform -translate-y-1/2 z-10 text-white font-medium text-2xl rounded-full shadow-lg">
                        <svg width="33" height="23" viewBox="0 0 33 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.406 18.399C13.0945 18.3994 12.7925 18.3248 12.5527 18.1881C12.4176 18.1112 12.306 18.0167 12.2242 17.91C12.1424 17.8034 12.092 17.6867 12.0759 17.5666C12.0598 17.4465 12.0784 17.3255 12.1304 17.2103C12.1825 17.0952 12.2671 16.9882 12.3793 16.8956L18.3527 11.9823L12.5927 7.05979C12.4819 6.96602 12.3992 6.85813 12.3493 6.74232C12.2994 6.62651 12.2833 6.50506 12.3018 6.38495C12.3204 6.26484 12.3734 6.14844 12.4576 6.04244C12.5418 5.93644 12.6557 5.84293 12.7927 5.76729C12.9306 5.68384 13.0922 5.62089 13.2672 5.5824C13.4422 5.54391 13.6269 5.53071 13.8097 5.54362C13.9925 5.55653 14.1694 5.59528 14.3294 5.65743C14.4894 5.71958 14.6289 5.80379 14.7393 5.90479L21.1793 11.4048C21.3754 11.5688 21.4826 11.7745 21.4826 11.9869C21.4826 12.1992 21.3754 12.4049 21.1793 12.569L14.5127 18.069C14.3789 18.1799 14.209 18.2676 14.0167 18.3249C13.8244 18.3822 13.6152 18.4076 13.406 18.399Z" fill="#F7F7F7" />
                        </svg>
                    </button>

                    <div
                        ref={carouselRef}
                        className="flex overflow-x-auto scroll-smooth space-x-3 scrollbar-hide snap-x snap-mandatory pl-4 pr-4"
                    >
                        {feedbacks.map((item, index) => (
                            <div
                                key={index}
                                className="snap-center flex-shrink-0 w-full md:w-1/2 bg-white rounded-[18px] shadow-lg p-8"
                            >
                                <p className="text-gray-600 mb-6 leading-relaxed">{item.message}</p>
                                <div className="flex justify-between items-center">
                                    <div className="flex items-center">
                                        <img
                                            src={item.image}
                                            alt={item.name}
                                            className="w-12 h-12 rounded-full mr-4"
                                        />
                                        <div>
                                            <div className="font-semibold">{item.name}</div>
                                            <div className="text-gray-700 text-sm">{item.desc}</div>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        {[...Array(item.rating)].map((_, i) => (
                                            <img src="/images/star.svg" alt="star" />

                                        ))}
                                        {[...Array(5 - item.rating)].map((_, i) => (
                                            <img src="/images/empty_star.svg" alt="empty star" />
                                        ))}
                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Feedback;
